<script lang="ts" setup>
import { promiseTimeout } from '@vueuse/core'
import { CircleEffectAtionName } from '../CircleMoveEffect/CircleEffectAtionName'

const isLoading = ref(false)
const router = useRouter()
const route = useRoute()
const { $lenis, $bus, hook } = useNuxtApp()

router.beforeEach(async (_to, _from, next) => {
  isLoading.value = true;
  $lenis.stop()
  await promiseTimeout(600)
  // 清理背景圆环动画状态
  $bus.emit(CircleEffectAtionName.Clear)
  next()
})

let timer: NodeJS.Timeout | null = null
hook('page:loading:end', () => {
  if (timer) clearTimeout(timer)

  timer = setTimeout(async () => {
    isLoading.value = false
    $bus.emit(CircleEffectAtionName.Init, route.name)
    await promiseTimeout(600) 
    if(route.name !=='index' && route.name !=='about'){
      $lenis.start()
    }
    timer = null
  }, 50)
})
</script>

<template>
  <div class="app-loading">
    <Transition name="slide-y">
      <div v-if="isLoading" class="content">
        <div class="wrapper">
          <img class="logo" src="@/assets/images/loding.webp" alt="">
          <img class="logo fill" src="@/assets/images/loding_fill.webp" alt="">

          <img class="logo2" src="@/assets/images/loding.webp" alt="">
          <img class="logo2 fill" src="@/assets/images/loding2_fill.webp" alt="">
        </div>
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
.app-loading {
  .content {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    will-change: transform;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9;
    .wrapper {
      width: 773px;
      height: 173px;
      position: relative;
      img{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
      .fill{
        // clip-path: inset(100% 0% 0% 0% round 0px);
        opacity: 0;
        animation: clip .3s .6s ease-in-out forwards;
        @keyframes clip {
          100%{
            opacity: 1;
            // clip-path: inset(0% 0% 0% 0% round 0px);
          }
        }
      }
    }
  }
}
#app {
  &.light {
    .app-loading {
      .content {
        background-color: #f1f0ec;
        .wrapper{
          .logo{
            display: block;
          }
          .logo2{
            display: none;
          }
        }
      }
    }
  }
  &.dark {
    .app-loading {
      .content {
        background-color: #252525;
        .wrapper{
          .logo{
            display: none;
          }
          .logo2{
            display: block;
          }
        }
      }
    }
  }
  &.xs{
    .app-loading{
      .content{
        .wrapper{
          width: 80%;
          img{
            object-fit: contain;
          }
        }
      }
    }
  }
}
</style>
